// extracted by mini-css-extract-plugin
module.exports = {"text":"Onboarding_text__fgDPC"};